"use client";

import React, { useState } from 'react';
import { TrackingForm } from '@/components/tracking/TrackingForm';
import { BookingDetailsCard } from '@/components/tracking/BookingDetailsCard';
import { bookingRepository } from '@/data/repositories';
import { Booking } from '@/domain/entities/booking.entity';
import { toast } from 'sonner';

export default function TrackingPage() {
    const [booking, setBooking] = useState<Booking | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleTrack = async (bookingId: string) => {
        setIsLoading(true);
        setBooking(null);

        try {
            const result = await bookingRepository.getBookingById(bookingId);
            if (result) {
                setBooking(result);
                toast.success('Booking found!');
            } else {
                toast.error('Booking not found. Please check your ID.');
            }
        } catch (error) {
            console.error('Error tracking booking:', error);
            toast.error('An error occurred while tracking your booking.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-background flex flex-col font-sans selection:bg-primary/20 pt-24 pb-16 lg:pt-32 lg:pb-24 px-4 items-center">
            <div className="w-full max-w-4xl mx-auto space-y-12">
                <div className="text-center space-y-4">
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-foreground leading-tight tracking-tight">
                        Track Your Booking
                    </h1>
                    <p className="text-muted-foreground text-sm md:text-base max-w-xl mx-auto leading-relaxed">
                        Enter your booking ID to view the latest status and details of your upcoming session.
                    </p>
                </div>

                <TrackingForm onTrack={handleTrack} isLoading={isLoading} />

                {booking && (
                    <div className="pt-8 animate-in fade-in slide-in-from-bottom-8 duration-700">
                        <BookingDetailsCard booking={booking} />
                    </div>
                )}
            </div>
        </div>
    );
}
